import React, { useEffect, useState } from 'react';
import API from '../services/api';
import { ANNOUNCEMENTS } from '../data/announcements';

const dismissKey = (id) => `announcement_dismissed_${id}`;

// Renders feature announcements (from data/announcements.js) for the given
// audience as dismissible banners. Dismissals persist per-user on the server;
// localStorage is only a fast local cache (it evaporates in private windows
// and browsers that clear site data, which used to resurrect old banners).
export default function AnnouncementBanner({ audience }) {
  const [items, setItems] = useState(() =>
    ANNOUNCEMENTS.filter(
      (a) =>
        (a.audience === 'all' || a.audience === audience) &&
        localStorage.getItem(dismissKey(a.id)) !== '1'
    )
  );

  useEffect(() => {
    let active = true;
    API.get('/therapist/announcement-dismissals')
      .then((res) => {
        if (!active || !res.data || !Array.isArray(res.data.ids)) return;
        const dismissed = new Set(res.data.ids);
        dismissed.forEach((id) => localStorage.setItem(dismissKey(id), '1'));
        setItems((prev) => prev.filter((a) => !dismissed.has(a.id)));
      })
      .catch(() => { /* non-fatal: fall back to localStorage only */ });
    return () => { active = false; };
  }, []);

  if (items.length === 0) return null;

  const dismiss = (id) => {
    localStorage.setItem(dismissKey(id), '1');
    setItems((prev) => prev.filter((a) => a.id !== id));
    API.post('/therapist/announcement-dismissals', { id }).catch(() => { /* best-effort */ });
  };

  return (
    <div style={{ marginBottom: 20 }}>
      {items.map((a) => (
        <div
          key={a.id}
          style={{
            display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap',
            background: 'linear-gradient(135deg, #1D2C5F 0%, #2F6E6A 100%)',
            color: '#fff', borderRadius: 14, padding: '14px 20px', marginBottom: 10,
            boxShadow: '0 6px 20px rgba(29,44,95,0.22)',
          }}
        >
          <div style={{ flex: 1, minWidth: 220, fontSize: 15, lineHeight: 1.4 }}>
            <span style={{ marginRight: 6 }}>{a.icon || '📢'}</span>
            <strong>{a.title}</strong>
            {a.text ? <span> — {a.text}</span> : null}
          </div>
          <button
            onClick={() => dismiss(a.id)}
            style={{
              background: 'transparent', color: 'rgba(255,255,255,0.9)',
              border: '1px solid rgba(255,255,255,0.55)', borderRadius: 8,
              padding: '8px 14px', fontWeight: 600, fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap',
            }}
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
